import { Navigate } from "react-router-dom";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";
import TenantDashboard from "@/pages/dashboard/TenantDashboard";
import Settings from "@/pages/settings";
// import Users from "@/pages/users";
import Subscription_Plan from "@/pages/subscription/Subscription";
import ROUTES from "@/config/routes";
import useAuthStore from "@/store/useAuthStore";
import TenantsTableFull from "@/components/TenantTableFull";
import UsageTableFull from "@/components/UsageTableFull";
import UsageTableFullTenant from "@/components/TenantsGraph";
import CompanyProfile from "@/pages/compnayprofile";
import CompanyProfileInfo from "@/pages/companyDetailsPage";
import UsageLogPage from "@/components/UsageLogs/UsageLogs";
import TEAMS from "@/pages/teams";
import CompanyProfileManual from "@/pages/companyProfileManual";
import Script from "@/pages/Script";
import CreditUsagePage from "@/pages/CreditUsage";

import ForgotPassword from "@/pages/ForgotPassword/ForgotPassword";
import SetNewPassword from "@/pages/ForgotPassword/ResetPassword";
import NotificationMenu from "@/pages/Notifications/NotificationMenu";
import Users from "@/pages/users";
import UserFormPage from "@/features/user/UserFormPage";
import Add_Company_Individual from "@/features/addCompanyOrIndividual/Add_Company_Individual";
import GrantCreditsPage from "@/pages/GrantCredits";
// import { Contact } from "lucide-react";
import ContactPage from "@/pages/contact/ContactPage";
import ContactRequestsPage from "@/pages/ContactRequests";
import AdminRequests from "@/pages/AdminRequests";
import MeetingDashboard from "@/pages/MeetingDashboard/MeetingDashboard";
import MeetingTypeListPage from "@/pages/MeetingDashboard/MeetingTypeListPage";
import MeetingDetailPage from "@/pages/MeetingDashboard/MeetingDetailPage";
import ScenarioLibrary from "@/pages/PracticeEngine/ScenarioLibrary";
import PitchTypeListPage from '@/pages/MeetingDashboard/PitchTypeListPage';
import ScriptDetailsPage from "@/pages/MeetingDashboard/ScriptDetailsPage";
import DigitalTwinTemplatesAdmin from "@/pages/DigitalTwinTemplatesAdmin";

// import PageNotFound from "@/pages/PageNotFound";
import { canViewBilling, canEditCompanyProfile, canViewMeetingDashboard, canViewPracticeEngine, canViewDigitalTwins, isManager } from '@/config/permissions';

export const useProtectedRoutes = () => {
  const role = useAuthStore((state) => state.role);
  return [
    {
      path: ROUTES.DASHBOARD,
      element: (() => {
        switch (role) {
          case "SUPER_ADMIN":
            return <AdminDashboard />;
          case "ADMIN":
            return <TenantDashboard />;
          case "MANAGER":
            return <TenantDashboard />;
        }
      })(),
    },

    {
      path: ROUTES.USAGECOUNT,
      element: (() => {
        switch (role) {
          case "SUPER_ADMIN":
            return <UsageTableFull />;
          case "ADMIN":
            return <UsageTableFullTenant view={""} />;
          case "MANAGER":
            return <UsageTableFullTenant view={""} />;
        }
      })(),
    },

    {
      path: ROUTES.TENANTS,
      element: (() => {
        switch (role) {
          case "SUPER_ADMIN":
            return <TenantsTableFull />;
        }
      })(),
    },
    {
      path: ROUTES.SUBSCRIPTION_PLAN,
      element: (() => {
        switch (role) {
          case "SUPER_ADMIN":
            return <Subscription_Plan />;
        }
      })(),
    },
    {
      path: ROUTES.TEAMS,
      element: (() => {
        switch (role) {
          case "ADMIN":
          case "MANAGER":
            return <TEAMS />;
          default:
            return <Navigate to={ROUTES.DASHBOARD} />;
        }
      })(),
    },

    { path: ROUTES.SETTINGS, element: <Settings /> },
    { path: ROUTES.SCRIPT, element: <Script /> },
    { path: ROUTES.SCRIPT_DETAILS, element: <ScriptDetailsPage /> },
    { 
      path: ROUTES.DIGITAL_TWIN_TEMPLATES, 
      element: canViewDigitalTwins(role) ? <DigitalTwinTemplatesAdmin /> : <Navigate to={ROUTES.DASHBOARD} /> 
    },
    { path: ROUTES.USER, element: <Users /> },
    { path: ROUTES.COMPANYPROFILEMANUAL, element: canEditCompanyProfile(role) ? <CompanyProfileManual /> : <Navigate to={ROUTES.DASHBOARD} /> },
    { path: ROUTES.COMPANYPROFILE, element: canEditCompanyProfile(role) ? <CompanyProfile /> : <Navigate to={ROUTES.DASHBOARD} /> },
    { path: ROUTES.COMPANYPROFILEINFO, element: <CompanyProfileInfo /> },
    { path: ROUTES.FORGOTPASSWORD, element: <ForgotPassword /> },
    { path: ROUTES.RESETPASSWORD, element: <SetNewPassword /> },
    { path: ROUTES.ADD_EDIT_USER, element: <UserFormPage /> },
    
    

    ...(role === "ADMIN" || role === "MANAGER" || role === "SUPER_ADMIN"
      ? [
        {
          path: ROUTES.USAGELOG,
          element: <UsageLogPage />,
        },
        {
          path: ROUTES.NOTIFICATION,
          element: <NotificationMenu />,
        },
        {
          path: ROUTES.CONTACT,
          element: <ContactPage />,
        },
         {
          path: "/pitch-type/:userId/:type",
          element: <PitchTypeListPage />
        },

      ]
      : []),
    ...(role === "SUPER_ADMIN" || role === "ADMIN"
      ? [
        {
          path: ROUTES.GRANT_CREDITS,
          element: <GrantCreditsPage />,
        },
      ]
      : []),
    ...(role === "SUPER_ADMIN"
      ? [
        {
          path: ROUTES.ADD_COMPANY_INDIVIDUAL,
          element: <Add_Company_Individual />,
        },
        {
          path: ROUTES.SCRIPT,
          element: <Script />,
        },
        {
          path: ROUTES.NOTIFICATION,
          element: <NotificationMenu />,
        },
        {
          path: ROUTES.CONTACT,
          element: <ContactPage />,
        },
        {
          path: ROUTES.CONTACT_REQUESTS,
          element: <ContactRequestsPage />,
        },
        {
          path: ROUTES.ADMIN_REQUESTS,
          element: <AdminRequests />,
        },
      ]
      : []),
    ...(canViewBilling(role)
      ? [
        {
          path: ROUTES.CREDIT_USAGE,
          element: <CreditUsagePage />,
        },
      ]
      : []),
    ...(canViewMeetingDashboard(role)
      ? [
        {
          path: "/meeting-dashboard",
          element: <MeetingDashboard />,
        },
        {
          path: "/all-meetings",
          element: <MeetingDashboard />,
        },
        {
          path: "/all-practice-sessions",
          element: <MeetingDashboard />,
        },
        {
          path: "/all-scripts",
          element: <MeetingDashboard />,
        },
        {
          path: "/meetings/:userId/:type",
          element: <MeetingTypeListPage />
        },
        { path:"/meeting-detail/:meetingId" ,
          element:<MeetingDetailPage />},
      ]
      : []),
    ...(canViewPracticeEngine(role)
      ? [
        {
          path: ROUTES.PRACTICE_ENGINE,
          element: <ScenarioLibrary />,
        },
      ]
      : []),
    
    // Catch-all redirects for role-restricted routes
    ...(isManager(role) ? [
      { path: ROUTES.CREDIT_USAGE, element: <Navigate to={ROUTES.DASHBOARD} /> },
      { path: "/meeting-dashboard", element: <Navigate to={ROUTES.DASHBOARD} /> },
      { path: "/meetings/:userId/:type", element: <Navigate to={ROUTES.DASHBOARD} /> },
      { path: "/meeting-detail/:meetingId", element: <Navigate to={ROUTES.DASHBOARD} /> },
      { path: ROUTES.PRACTICE_ENGINE, element: <Navigate to={ROUTES.DASHBOARD} /> },
      { path: ROUTES.DIGITAL_TWIN_TEMPLATES, element: <Navigate to={ROUTES.DASHBOARD} /> },
    ] : []),
  ];
};
